import { useTranslation } from 'react-i18next'

import { useSettingsStore } from 'stores/settingsStore'

import Icon from 'components/Icon'
import Logo from 'modules/Logo'

import style from './index.module.scss'

const Footer = () => {
  const { t } = useTranslation()
  const { settings } = useSettingsStore()

  return (
    <footer className={style.block}>
      <div className={style.copyright}>
        <div className={style.info}>
          <p>{t('footer.legal_text_1')}</p>
          <p>{t('footer.legal_text_2')}</p>
        </div>
        <div className={style.socials}>
          {
            settings.social.map((el, idx) =>
              <a
                key={idx}
                href={el.link}
                className={style.link}
                aria-label={el.link}
              >
                <Icon name={`icon-misc-${el.icon}`} />
              </a>
            )
          }
        </div>
        <Logo/>
      </div>
    </footer>
  )
}

export default Footer
